import './App.css';
import { lazy,useEffect} from 'react';
import { BrowserRouter,Routes,Route } from "react-router-dom";

const PageLp = lazy(()=>import('./Pages/Lp/PageLp.js'));
const PageCustomer1 = lazy(()=>import('./Pages/Lp/PageCustomer1.js'));
const PageCustomer2 = lazy(()=>import('./Pages/Lp/PageCustomer2.js'));
const PageCustomer3 = lazy(()=>import('./Pages/Lp/PageCustomer3.js'));
const PageReserve = lazy(()=>import('./Pages/Reserve/PageReserve.js'));
const PageDownload = lazy(()=>import('./Pages/Download/PageDownload.js'));

function App() {

  useEffect(()=>{
    const hashSave = window.location.hash
    window.location.hash = ""
    window.location.hash = hashSave

    // console.log(hashSave)
    
  },[])
  
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path={"/customers/oneup"} element={<PageCustomer1/>}/>
          <Route path={"/customers/widelink"} element={<PageCustomer2/>}/>
          <Route path={"/customers/bestsupport"} element={<PageCustomer3/>}/>
          <Route path={"/reserve"} element={<PageReserve/>}/>
          <Route path={"/download"} element={<PageDownload/>}/>
          <Route path={"/*"} element={<PageLp/>}/>
        </Routes>

      </BrowserRouter>
    </div>
  );
}

export default App;
